import React, { useState } from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import DeleteIcon from "@mui/icons-material/Delete";
import "../AddInstructions/deleteinstruction.css";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { deleteInstruction } from "../instructions";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};
export default function DeleteStudy({ element, getInstructions }) {
  const [opened, setOpened] = useState(false);
  const [loading, setLoading] = useState(false);
  const id = element.id;
  const handleDeleteOpen = () => {
    setOpened(true);
  };

  const handleDeleteClose = () => {
    setOpened(false);
  };

  const handleDelete = async () => {
    if (loading === false) {
      setLoading(true);
      const response = await deleteInstruction({ id });
      if (response) {
        setLoading(false);
        if (response.success === true) {
          getInstructions();
        }
      }
    }
  };

  return (
    <div>
      <button
        style={{
          border: "none",
          backgroundColor: "white",
        }}
        onClick={handleDeleteOpen}
      >
        <DeleteIcon
          sx={{
            fontSize: "20px",
            color: "#565656;",
          }}
        />
      </button>
      <BootstrapDialog
        onClose={handleDeleteClose}
        aria-labelledby="customized-dialog-title"
        open={opened}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "671px",
              minHeight: "380px",
            },
          },
        }}
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleDeleteClose}
          sx={{
            background: "#093975",
            color: "white",
            fontFamily: "RaleWay",
            fontWeight: "600",
          }}
        >
          Delete Instruction
        </BootstrapDialogTitle>
        <DialogContent dividers className="AddStudyContainer">
          <div>
            <div className="row">
              <div className="col-lg-5"></div>
              <div className="col-lg-2">
                <ExclamationCircleOutlined
                  style={{
                    fontSize: "50px",
                    marginTop: "35px",
                    marginBottom: "20px",
                  }}
                />
              </div>
              <div className="col-lg-5"></div>
            </div>

            <p className="areYou">
              Are you sure you want to permanently delete this Instruction?{" "}
            </p>
            <p className="onceCompleted">
              Once completed, the action can not be undone.
            </p>
          </div>
        </DialogContent>
        <DialogActions>
          <button
            autoFocus
            onClick={handleDeleteClose}
            className="deleteInstructionCancelBtn"
          >
            Cancel
          </button>
          <button
            autoFocus
            onClick={handleDelete}
            className={
              loading
                ? "deleteInstructionSaveBtn_loading"
                : "deleteInstructionSaveBtn"
            }
          >
            Yes,Delete
          </button>
        </DialogActions>
      </BootstrapDialog>
    </div>
  );
}
